export type ChatScrollingCleanup = () => void;

export function manageScrolling(classSelector: string): ChatScrollingCleanup | undefined {
  const found = document.getElementsByClassName(classSelector)[0] as HTMLElement | undefined;
  if (!found || found.dataset['scrollManagerInitialized'] === 'true') {
    return undefined;
  }

  const element: HTMLElement = found;
  element.dataset['scrollManagerInitialized'] = 'true';
  let isScrollLockedToEnd = true;

  scrollToEnd();
  enableScrollLock();

  const onScroll = () => {
    if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
      enableScrollLock();
    } else {
      disableScrollLock();
    }
  };
  element.addEventListener('scroll', onScroll);

  const observer = new MutationObserver(() => {
    if (isScrollLockedToEnd) {
      scrollToEnd();
    } else if (element.clientHeight === element.scrollHeight) {
      enableScrollLock();
    }
  });

  const config: MutationObserverInit = { attributes: true, childList: true, subtree: true, characterData: true };
  observer.observe(element, config);

  function enableScrollLock() {
    isScrollLockedToEnd = true;
    element.classList.add('scroll-locked');
  }

  function disableScrollLock() {
    isScrollLockedToEnd = false;
    element.classList.remove('scroll-locked');
  }

  function scrollToEnd() {
    element.scrollTop = element.scrollHeight;
  }

  return () => {
    observer.disconnect();
    element.removeEventListener('scroll', onScroll);
    delete element.dataset['scrollManagerInitialized'];
  };
}

export function manageHorizontalScrolling(classSelector: string): ChatScrollingCleanup | undefined {
  const found = document.getElementsByClassName(classSelector)[0] as HTMLElement | undefined;
  if (!found || found.dataset['horizontalScrollManagerInitialized'] === 'true') {
    return undefined;
  }

  const element: HTMLElement = found;
  element.dataset['horizontalScrollManagerInitialized'] = 'true';
  let isScrollLockedToEnd = true;

  scrollToEnd();
  enableScrollLock();

  const onScroll = () => {
    if (element.scrollLeft + element.clientWidth >= element.scrollWidth - 2) {
      enableScrollLock();
    } else {
      disableScrollLock();
    }
  };
  element.addEventListener('scroll', onScroll);

  const observer = new MutationObserver(() => {
    if (isScrollLockedToEnd) {
      scrollToEnd();
    } else if (element.clientWidth >= element.scrollWidth) {
      enableScrollLock();
    }
  });

  const config: MutationObserverInit = { attributes: true, childList: true, subtree: true, characterData: true };
  observer.observe(element, config);

  function enableScrollLock() {
    isScrollLockedToEnd = true;
    element.classList.add('scroll-locked-horizontal');
  }

  function disableScrollLock() {
    isScrollLockedToEnd = false;
    element.classList.remove('scroll-locked-horizontal');
  }

  function scrollToEnd() {
    element.scrollLeft = element.scrollWidth;
  }

  return () => {
    observer.disconnect();
    element.removeEventListener('scroll', onScroll);
    delete element.dataset['horizontalScrollManagerInitialized'];
  };
}
